import React from 'react';
import sculptureSyle from './style';
import slideSystem from '../../components/pageSlideSystem/slideSystem';
import Page00 from './pages/page00';
import Page01 from './pages/page01';
import Page02 from './pages/page02';
import Page03 from './pages/page03';
import Page04 from './pages/page04';
import Page05 from './pages/page05';
import Page06 from './pages/page06';
import Page07 from './pages/page07';
import Page08 from './pages/page08';
import Page09 from './pages/page09';
import Page10 from './pages/page10';
import Page11 from './pages/page11';
import Page12 from './pages/page12';
import Page13 from './pages/page13';
import Page14 from './pages/page14';
import Page15 from './pages/page15';
import Page16 from './pages/page16';
import Page17 from './pages/page17';
import Page18 from './pages/page18';
import Page19 from './pages/page19';
import Page20 from './pages/page20';
import Page21 from './pages/page21';
import Page22 from './pages/page22';
import Page23 from './pages/page23';
import Page24 from './pages/page24';
import Page25 from './pages/page25';
import Page26 from './pages/page26';
import Page27 from './pages/page27';
import Page28 from './pages/page28';
import Page29 from './pages/page29';
import Page30 from './pages/page30';
import Page31 from './pages/page31';
import Page32 from './pages/page32';
import coursesInfo from '../payment/courseInformation';

export default function Sculpture() {
	let courseInfo = coursesInfo[1];

	let SculptureSlide = slideSystem(
		[
			Page00,
			Page01,
			Page02,
			Page03,
			Page04,
			Page05,
			Page06,
			Page07,
			Page08,
			Page09,
			Page10,
			Page11,
			Page12,
			Page13,
			Page14,
			Page15,
			Page16,
			Page17,
			Page18,
			Page19,
			Page20,
			Page21,
			Page22,
			Page23,
			Page24,
			Page25,
			Page26,
			Page27,
			Page28,
			Page29,
			Page30,
			Page31,
			Page32,
		],
		{
			next: scrollToTop,
			back: scrollToTop,
		},
		{courseInfo: courseInfo}
	);

	return <>{SculptureSlide}</>;
}

function scrollToTop() {
	if ('scrollRestoration' in history) {
		history.scrollRestoration = 'manual';
	}

	window.scrollTo(0, 0);
}
